import React from 'react';

const Checkbox = (props) => {
    const {
        name        = '',
        label       = '',
        checked     = false,
        onChange    = (value) => {},
        disabled    = false,
    } = props;

    return (
        <div className={'form-input-checkbox-container'}>
            <div className={'checkbox-outer'}>
                <input type="checkbox"
                       checked={checked}
                       name={name}
                       id={name}
                       disabled={disabled}
                       onChange={() => onChange(!checked)}
                />
                <label htmlFor={name}>&times;</label>
            </div>
            <div className={"checkbox-label"} dangerouslySetInnerHTML={{ __html: label}} />
        </div>
    )
}

export default Checkbox;
